const mappingsTools = require('@/utils/mapTools')
const industryList = require('@/utils/industryList')
const DATA_MAP = {
  demandsType: [{
      label: '技术购买',
      value: '1'
    },
    {
      label: '产品需求',
      value: '2'
    },
    {
      label: '服务需求',
      value: '3'
    },
    {
      label: '其他需求',
      value: '4'
    }
  ],
  mainSubject: [{
      label: '国有企业',
      value: 'stateOwner'
    },
    {
      label: '民营企业',
      value: 'privately'
    },
    {
      label: '个人',
      value: 'personage'
    },
    {
      label: '其他',
      value: 'other'
    }
  ],
  companyType: [{
    label: '企业',
    value: '1'
  },
  {
    label: '个人',
    value: '2'
  },
  {
    label: '其他',
    value: '3'
  }
  ],
  operationType: [{
      label: '待转化',
      value: '0'
    },
    {
      label: '许可',
      value: '1'
    },
    {
      label: '质押',
      value: '2'
    },
    {
      label: '转让',
      value: '3'
    }, 
    {
      label: '免费许可', //免费许可
      value: '4'
    },
  ],
  // tradePublicityType: [
  //   { label: '转让', value: '0' },
  //   { label: '许可', value: '1' },
  //   { label: '质押', value: '2' }
  // ],
  auditStatus: [{
      label: '待审核',
      value: 0
    },
    {
      label: '审核通过',
      value: 1
    },
    {
      label: '审核不通过',
      value: 2
    }
  ],
  type: [{
      label: '待转化',
      value: '0'
    },
    {
      label: '许可',
      value: '1'
    },
    {
      label: '质押',
      value: '2'
    },
    {
      label: '转让',
      value: '3'
    }
  ],
  financialType: [{
      label: '金融机构',
      value: '1'
    },
    {
      label: '商业银行',
      value: '2'
    },
    {
      label: '担保公司',
      value: '3'
    },
    {
      label: '保险公司',
      value: '4'
    }
  ],
  informationType: [{
      label: '行业资讯',
      value: '1'
    },
    {
      label: '政策制度',
      value: '2'
    },
    {
      label: '产业分析',
      value: '3'
    },
    {
      label: '金融产品',
      value: '4'
    }
  ],
  status: [{
      label: '未发布',
      value: '0'
    },
    {
      label: '已发布',
      value: '1'
    }
  ],
  industry: [{
      label: '代理服务',
      value: '1'
    },
    {
      label: '法律状态',
      value: '2'
    },
    {
      label: '咨询服务',
      value: '3'
    },
    {
      label: '信息服务',
      value: '4'
    },
    {
      label: '企业管理',
      value: '5'
    }
  ],
  useStatus: [{
      label: '启用',
      value: '0'
    },
    {
      label: '停用',
      value: '1'
    }
  ],
  patentType: [{
      label: '发明专利',
      value: '0'
    },
    {
      label: '实用新型',
      value: '1'
    },
    {
      label: '外观设计',
      value: '2'
    },
    {
      label: '其他',
      value: '3'
    }
  ],
  thirdServiceType: [{
      label: '知识产权',
      value: '1'
    },
    {
      label: '资助认证',
      value: '2'
    },
    {
      label: '法律服务',
      value: '3'
    },
    {
      label: '金融服务',
      value: '4'
    },
    {
      label: '培训服务',
      value: '5'
    },
    {
      label: '信息服务',
      value: '6'
    }
  ],
  expertsType: [{
      label: '知识产权专家',
      value: '1'
    },
    {
      label: '专业技术专家',
      value: '2'
    }
  ],
  industryList: industryList.industryList,
  orgType: [{
      label: '高校院所',
      value: '0'
    },
    {
      label: '科研单位',
      value: '1'
    },
    {
      label: '国企单位',
      value: '2'
    }
  ],
  technicalType: [{
      label: '人类生活必需',
      value: '0'
    },
    {
      label: '作业；运输',
      value: '1'
    },
    {
      label: '化学；冶金',
      value: '2'
    },
    {
      label: '纺织；造纸',
      value: '3'
    },
    {
      label: '固定建筑物',
      value: '4'
    },
    {
      label: '机械工程；照明；加热；武器；爆破',
      value: '5'
    },
    {
      label: '物理',
      value: '6'
    },
    {
      label: '电学',
      value: '7'
    }
  ]
}
const v2Label = mappingsTools.key2Value(DATA_MAP) // 映射表数据处理

module.exports = {
  v2Label
}